export default __webpack_public_path__ + "static/media/sign.6177df0e.jpg";